import { colors } from 'nicollet-tokens';

const ndsFormStyles = {
  colors: {
    text: {
      disabled: colors.palette.gray.medium,
      placeholder: colors.palette.gray.medium
    },
    border: {
      disabled: colors.palette.gray.medium
    },
    background: {
      disabled: colors.palette.gray.lightest
    },
    alert: {
      warning: {
        background: '#FFF5EB',
        border: colors.palette.orange.default,
        text: colors.alert.warning
      },
      success: {
        text: colors.palette.green.default
      }
    }
  }
};

export { ndsFormStyles };
